<template>
  <div class="listitem">
    <!-- 预授权 -->
    <template v-if="item.dataType === '0'">
      <!-- 头部 -->
      <div class="itemtop">
        <div class="topleft">
          <!-- 预授权标识 -->
          <span :class="{ preAuth: enflags == true }"></span>
          <!-- 0：报案编号；1：授权编号 -->
          <span
            >{{ $t(`progressItem.payNum${item.claimsType === '0' ? '2' : ''}`)
            }}{{ item.approvalCode || item.claimsId }}</span
          >
        </div>
        <!-- 案件状态 -->
        <span class="topright" v-if="item.claimsStatus != '99'">
          <template v-if="enflags">
            {{ item.claimsStatus | filterStatusPre(statusOptionsp) }}
          </template>
          <template v-else>{{ item.claimsStatusDesc }}</template></span
        >
        <!-- 案件状态：99（多案件报案），只有一个案件 -->
        <span
          class="topright"
          v-if="item.claimsStatus === '99' && item.list.length === 1"
        >
          <template v-if="enflags">
            {{ item.list[0].claimsStatus | filterStatusPre(statusOptionsp) }}
          </template>
          <template v-else>{{ item.list[0].claimsStatus }}</template></span
        >
        <!-- 案件状态：99（多案件报案），案件数量 > 1 -->
        <span
          class="topright moreright"
          v-if="item.claimsStatus === '99' && item.list.length > 1"
        >
          <span class="iconew"></span>
          {{ $t('text.ownExpenseDetail.tit') }}
        </span>
      </div>
      <!-- 主体内容 -->
      <div class="itemmid" @click="goDetail(item.claimsId, item.claimsType)">
        <!-- 保单号/出险人 -->
        <p>
          {{ $t('progressItem.serPerson') }}：{{ item.policyNo | filterData() }}
          {{ item.insured | filterData() }}
        </p>
        <!-- 医疗机构 -->
        <p>
          {{ $t('progressItem.place') }}：{{ item.providerName | filterData() }}
        </p>
        <!-- 就诊日期 -->
        <p v-if="item.docrcvdt">
          {{ $t('progressItem.date') }}：{{ item.docrcvdt.substring(0, 10) }}
        </p>
        <!-- 诊断说明 -->
        <p>
          {{ $t('progressItem.diagnose') }}：{{ item.diagnosis | filterData() }}
        </p>
        <!-- 备注 -->
        <p v-if="item.remarkCatgDesc" class="pred">
          {{ $t('progressItem.need') }}：
          <span class="red">{{ item.remarkCatgDesc }}</span>
        </p>
        <!-- 底部按钮区 -->
        <p>
          <!-- 案件创建时间 -->
          <span>{{ item.createDate | filterData() }}</span>
          <span>
            <!-- 取消案件 -->
            <span
              v-if="['10', '20', '30'].includes(item.claimsStatus)"
              @click.stop="btnOp('cancel', item.claimsId)"
              >{{ $t('progressItem.cancel') }}</span
            >
          </span>
        </p>
      </div>
    </template>
    <!-- 理赔 -->
    <template v-else>
      <!-- 头部 -->
      <div class="itemtop" v-if="item.dataType === '1'">
        <div class="topleft">
          <!-- 理赔标识（1：直付；2：事后） -->
          <span :class="claimsFlagCls"></span>
          <!-- 0：报案编号；1：理赔编号 -->
          <span
            >{{ $t(`progressItem.payNum${item.claimsType === '0' ? '2' : '1'}`)
            }}{{ item.cliamsId }}</span
          >
        </div>
        <!-- 理赔状态 -->
        <span
          class="topright"
          :style="enflags ? 'width: 160px' : ''"
          v-if="item.claimsStatus != '99'"
          >{{ item.claimsDesc }}</span
        >
        <!-- 理赔状态：99（多案件报案），只有一个案件 -->
        <span
          class="topright"
          v-if="
            item.claimsStatus === '99' &&
            item.cliamsCount === 1 &&
            enflags === false
          "
        >
          <template v-if="enflags">
            {{ item.claimsStatus | filterStatusClaim(statusOptionsclaim) }}
          </template>
          <template v-else>{{ item.claimsStatus }}</template></span
        >
        <!-- 理赔状态：99（多案件报案），案件数量 > 1 -->
        <span
          class="topright moreright"
          v-if="item.claimsStatus === '99' && item.cliamsCount > 1"
        >
          <span class="iconew"></span>
          {{ $t('text.ownExpenseDetail.tit1') }}
        </span>
      </div>
      <!-- 主体内容 -->
      <div
        class="itemmid"
        @click="goDetail(item.cliamsId, item.claimsType, item.proSts)"
      >
        <!-- 保单号/出险人 -->
        <p>
          {{ $t('progressItem.serPerson') }}：{{ item.policyNo | filterData() }}
          {{ item.patient | filterData() }}
        </p>
        <!-- 医疗机构 -->
        <p>
          {{ $t('progressItem.place') }}：{{ item.providerName | filterData() }}
        </p>
        <!-- 就诊日期 -->
        <p>
          {{ $t('progressItem.date') }}：{{
            item.docrcvdt != '' && item.docrcvdt != null
              ? item.docrcvdt.substring(0, 10)
              : '--'
          }}
        </p>
        <!-- 审核日期 -->
        <p>
          {{ $t('progressItem.examDate') }}：{{
            item.lasteditDate
              ? dayjs(item.lasteditDate).format('YYYY/MM/DD')
              : '--'
          }}
        </p>
        <!-- 结案时间 -->
        <p>
          {{ $t('progressItem.closeTime') }}：{{
            item.closeDate ? dayjs(item.closeDate).format('YYYY/MM/DD') : '--'
          }}
        </p>
        <!-- 取消原因 -->
        <p v-if="item.declineReason">
          {{ $t('progressItem.cancleReason') }}{{ item.declineReason }}
        </p>
        <!-- 备注 -->
        <p v-if="item.remark">
          {{ $t('progressItem.remark') }}： {{ item.remark }}
        </p>
        <!-- 不计入门诊次数提示 -->
        <p v-if="item.benefitRemarkFlag" :style="{ color: '#e94b2c' }">
          {{ $t('claimQuery.noReduceTip') }}
        </p>
        <!-- 底部按钮区 -->
        <p>
          <!-- 案件创建时间 -->
          <span>{{ item.createDate }}</span>
          <!-- 事后案件 -->
          <template v-if="item.claimsType === '0'">
            <!-- 案件数为0 -->
            <span v-if="item.cliamsCount === '0'">
              <!-- 上传材料v-if="item.claimsType === '0' -->
              <span
                v-if="['10', '20'].includes(item.claimsStatus)"
                @click.stop="
                  btnOp(
                    'material',
                    item.cliamsId,
                    item.claimsType,
                    '',
                    '',
                    item.claimsStatus
                  )
                "
              >
                {{ $t('progressItem.material') }}
              </span>
              <!-- 取消案件 -->
              <span
                v-if="['10', '20', '30'].includes(item.claimsStatus)"
                @click.stop="
                  btnOp('cancel', item.cliamsId, item.claimsType, item.policyNo)
                "
              >
                {{ $t('progressItem.cancel') }}
              </span>
            </span>
            <!-- 案件数量为1 -->
            <span v-else-if="item.cliamsCount === '1'">
              <!-- 上传材料 -->
              <span
                v-if="item.claimsStatus === '07'"
                @click.stop="
                  btnOp(
                    'material',
                    item.cliamsId,
                    item.claimsType,
                    '',
                    '',
                    item.claimsStatus
                  )
                "
                >{{ $t('progressItem.material1') }}</span
              >
              <!-- 理赔解释 -->
              <span
                v-if="['08', '09', '10', '11'].includes(item.claimsStatus)"
                @click.stop="btnOp('des', item.singleCalimsId, item.claimsType)"
              >
                {{ $t('progressItem.des1') }}
              </span>
            </span>
            <!-- 案件数量 > 1 -->
            <span v-else>
              <span
                v-if="item.materialStatus === 'Y'"
                @click="goDetail(item.cliamsId, item.claimsType, item.proSts)"
                >{{ $t('progressItem.materialStatus') }}</span
              >
            </span>
          </template>
          <!-- 不是事后案件 -->
          <span v-else>
            <!-- 补充材料 -->
            <span
              v-if="item.claimsStatus === '07' && item.proSts != '5620'"
              @click.stop="
                btnOp(
                  'material',
                  item.cliamsId,
                  item.claimsType,
                  '',
                  '',
                  item.claimsStatus
                )
              "
            >
              {{ $t('progressItem.material1') }}
            </span>
            <!-- 理赔解释 -->
            <span
              v-if="['08', '09', '10', '11'].includes(item.claimsStatus)"
              @click.stop="btnOp('des', item.cliamsId, item.claimsType)"
            >
              {{ $t('progressItem.des1') }}
            </span>
          </span>
        </p>
      </div>
    </template>
  </div>
</template>

<script>
import dayjs from 'dayjs'
// 预授权案件状态码表（英文）
const statusOptionsp = [
  {
    value: '39',
    text: 'Cancelled'
  },
  {
    value: '10',
    text: 'Authorization application submitted'
  },
  {
    value: '20',
    text: 'Authorization application submitted'
  },
  {
    value: '30',
    text: 'Pre-authorized materials to be reviewed'
  },
  {
    value: '40',
    text: 'Material review,file case'
  },
  {
    value: '50',
    text: 'Authorized materials failed'
  },
  {
    value: '05',
    text: 'Under review'
  },
  {
    value: '01',
    text: 'Waitting supplementary materials'
  },
  {
    value: '02',
    text: 'Review for approval by the insurer'
  },
  {
    value: '03',
    text: 'Review passed'
  },
  {
    value: '04',
    text: 'Review failed'
  }
]
// 理赔案件状态码表（英文）
const statusOptionsclaim = [
  {
    value: '39',
    text: 'Cancelled'
  },
  {
    value: '10',
    text: 'Image upload failed'
  },
  {
    value: '20',
    text: 'Image upload failed'
  },
  {
    value: '30',
    text: 'Claims materials to be reviewed'
  },
  {
    value: '40',
    text: 'Material review,file case'
  },
  {
    value: '50',
    text: 'Claim materials failed to pass the review'
  },
  {
    value: '05',
    text: 'Under review'
  },
  {
    value: '07',
    text: 'Waitting supplementary materials'
  },
  {
    value: '06',
    text: 'Review for approval by the insurer'
  },
  {
    value: '08',
    text: 'Review passed'
  },
  {
    value: '09',
    text: 'Case closed'
  },
  {
    value: '10',
    text: 'Case closed,Pending payment'
  },
  {
    value: '11',
    text: 'Case closed,Paid'
  }
]
export default {
  props: {
    // 数据对象
    item: {
      type: Object
    }
  },
  data() {
    return {
      enflags: false, // 是否英文模式
      statusOptionsp: Object.seal(statusOptionsp), // 预授权案件状态码表（英文）
      statusOptionsclaim: Object.seal(statusOptionsclaim) // 理赔案件状态码表（英文）
    }
  },
  filters: {
    // 根据状态code过滤英文模式下的预授权状态
    filterStatusPre: (val, statusOptionsp) => {
      if (!val) {
        return ''
      } else {
        let textCon = ''
        statusOptionsp.map((item) => {
          if (item.value == val) {
            textCon = item.text
          }
        })
        return textCon
      }
    },
    // 根据状态code过滤英文模式下的理赔状态
    filterStatusClaim: (val, statusOptionsclaim) => {
      if (!val) {
        return ''
      } else {
        let textCon = ''
        statusOptionsclaim.map((item) => {
          if (item.value == val) {
            textCon = item.text
          }
        })
        return textCon
      }
    },
    // 处理空数据
    filterData: (val) => {
      if (val === '' || val === null || val === undefined) {
        return '--'
      } else {
        return val
      }
    }
  },
  computed: {
    // 理赔标识元素类名
    claimsFlagCls() {
      let cls = ''
      cls = this.item.claimsType == '1' ? 'zhifu' : 'shihou'
      if (this.enflags) {
        const cls1 = `${cls}1`
        cls += cls1
      }
      console.log(cls)
      return cls
    }
  },
  mounted() {
    // 是否英文模式
    if (this.$i18n.locale === 'en-us') {
      this.enflags = true
    }
  },
  methods: {
    dayjs,
    goDetail(claimsId, claimsType, proSts = null) {
      this.$emit('goDetail', claimsId, claimsType, proSts)
    },
    btnOp(type, claimsId, claimsType, policyNo, memberNo, status, item) {
      this.$emit(
        'btnOp',
        type,
        claimsId,
        claimsType,
        policyNo,
        memberNo,
        status,
        item
      )
    }
  }
}
</script>
<style scoped lang="scss">
.listitem {
  background-color: #fff;
  border-radius: 10px;
  margin-bottom: 10px;
  font-size: 13px;
  color: #666;
  padding: 15px 15px;
  .itemtop {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 14px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    .topleft {
      display: flex;
      align-items: center;
      span {
        font-size: 14px;
        color: #333;
        display: flex;
        align-items: center;
        text-align: left;
        font-weight: bold;
        line-height: 15px;
        &:first-child {
          width: 39px;
          height: 15px;
          background: url(~@/assets/image/common/preAuthImg.png) center center
            no-repeat;
          background-size: contain;
          margin-right: 10px;
          &.preAuth {
            background: url(~@/assets/image/common/preAuthImg1.jpg) center
              center no-repeat;
            background-size: contain;
          }
          &.shihou {
            background: url(~@/assets/image/common/shihou.png) center center
              no-repeat;
            background-size: contain;
          }
          &.zhifu {
            background: url(~@/assets/image/common/zhifu.png) center center
              no-repeat;
            background-size: contain;
          }
          &.shihou1 {
            background: url(~@/assets/image/common/shihou1.jpg) center center
              no-repeat;
            background-size: contain;
          }
          &.zhifu1 {
            background: url(~@/assets/image/common/zhifu1.jpg) center center
              no-repeat;
            background-size: contain;
          }
        }
      }
    }
    .topright {
      display: inline-block;
      font-size: 12px;
      padding: 1.5px 5px;
      color: #e94b2c;
      text-align: right;
    }
  }
  .itemmid {
    padding: 15px 0 0;
    font-size: 13px;
    color: #999;
    text-align: left;
    p {
      margin-bottom: 5px;
      line-height: 16px;
      span.red {
        color: #e94b2c;
      }
      &:last-child {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        margin-top: 20px;
        & > span {
          &:first-child {
            font-size: 11px;
            color: #ccc;
            line-height: 13px;
            position: relative;
            top: 5px;
          }
          &:last-child {
            font-size: 12px;
            white-space: nowrap;
            span {
              color: #c7a283;
              border: 1px solid #c7a283;
              border-radius: 3px;
              padding: 3px 9px;
              margin-right: 10px;
            }
            span:last-child {
              color: #999;
              border: 1px solid #999;
              border-radius: 3px;
              padding: 3px 9px;
              margin-right: 0;
            }
          }
        }
      }
    }
  }
}
.listitem .itemtop .topright.moreright {
  display: flex;
  align-items: center;
  color: #c7a283;
  .iconew {
    display: inline-block;
    margin-right: 5px;
    width: 12px;
    height: 12px;
    background: url(~@/assets/image/common/iconnew.png) center center no-repeat;
    background-size: 12px 12px;
  }
}
.page_.enpage {
  padding-top: 72px;
  .itemmid {
    p:last-child {
      & > span:last-child {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        span {
          margin-bottom: 5px;
          margin-right: 0;
        }
      }
    }
  }
}
</style>
